module.exports = __webpack_public_path__ + "static/img/DeWise.8b654bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/DeWise.png
// module id = 5rcF
// module chunks = 0